// @ts-nocheck
/// <reference path="types.d.ts"/>
/** @module ProductList */
// Auto-generated, edits will be overwritten
import * as gateway from './gateway';

/**
 * Fetch all product lists for authenticated user
 * 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] Storefront base URL for context e.g. *mystore.mygrano.fi*
 * @return {Promise<module:types.ProductListWithProducts[]>} OK
 */
export function myLists(options?: MyListsOptions): Promise<api.Response<api.ProductListWithProducts[]>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    }
  };
  return gateway.request(myListsOperation, parameters);
}

/**
 * Create a product list for authenticated user in active store
 * 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] Storefront base URL for context e.g. *mystore.mygrano.fi*
 * @param {object} [options.body] 
 * @return {Promise<module:types.ProductListWithProducts>} OK
 */
export function create(options?: CreateOptions): Promise<api.Response<api.ProductListWithProducts>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    body: {
      body: options.body
    }
  };
  return gateway.request(createOperation, parameters);
}

/**
 * Update product list for authenticated user in active store
 * 
 * @param {number} id 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] Storefront base URL for context e.g. *mystore.mygrano.fi*
 * @param {object} [options.body] 
 * @return {Promise<module:types.ProductListWithProducts>} OK
 */
export function update(id: number, options?: UpdateOptions): Promise<api.Response<api.ProductListWithProducts>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id
    },
    body: {
      body: options.body
    }
  };
  return gateway.request(updateOperation, parameters);
}

/**
 * Delete product list for authenticated user in active store
 * 
 * @param {number} id 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] Storefront base URL for context e.g. *mystore.mygrano.fi*
 * @return {Promise<module:types.ProductList>} OK
 */
export function destroy(id: number, options?: DestroyOptions): Promise<api.Response<api.ProductList>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id
    }
  };
  return gateway.request(destroyOperation, parameters);
}

/**
 * Get all product lists for the current user
 * 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto[]>} 
 */
export function getProductLists(options?: GetProductListsOptions): Promise<api.Response<api.ProductListWithProductsDto[]>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    }
  };
  return gateway.request(getProductListsOperation, parameters);
}

/**
 * Create a new product list
 * 
 * @param {module:types.ProductListDto} productList 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto>} 
 */
export function createProductList(productList: api.ProductListDto, options?: CreateProductListOptions): Promise<api.Response<api.ProductListWithProductsDto>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    body: {
      productList
    },
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    }
  };
  return gateway.request(createProductListOperation, parameters);
}

/**
 * Update a product list by its ID
 * 
 * @param {number} id Product List ID
 * @param {module:types.ProductListDto} productList 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto>} 
 */
export function updateProductList(id: number, productList: api.ProductListDto, options?: UpdateProductListOptions): Promise<api.Response<api.ProductListWithProductsDto>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id
    },
    body: {
      productList
    }
  };
  return gateway.request(updateProductListOperation, parameters);
}

/**
 * Delete a product list by its ID
 * 
 * @param {number} id Product List ID
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<object>} 
 */
export function deleteProductList(id: number, options?: DeleteProductListOptions): Promise<api.Response<undefined>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id
    }
  };
  return gateway.request(deleteProductListOperation, parameters);
}

/**
 * Add an item to a product list
 * 
 * @param {number} id Product List ID
 * @param {module:types.CartItemDto} cartItem 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto>} 
 */
export function addProductListItem(id: number, cartItem: api.CartItemDto, options?: AddProductListItemOptions): Promise<api.Response<api.ProductListWithProductsDto>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id
    },
    body: {
      cartItem
    }
  };
  return gateway.request(addProductListItemOperation, parameters);
}

/**
 * Remove an item from a product list
 * 
 * @param {number} id Product List ID
 * @param {string} itemId Product List Item ID (UUID)
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto>} 
 */
export function removeProductListItem(id: number, itemId: string, options?: RemoveProductListItemOptions): Promise<api.Response<api.ProductListWithProductsDto>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id,
      itemId
    }
  };
  return gateway.request(removeProductListItemOperation, parameters);
}

/**
 * Update an item in a product list
 * 
 * @param {number} id Product List ID
 * @param {string} itemId Product List Item ID (UUID)
 * @param {module:types.CartItemDto} cartItem 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto>} 
 */
export function updateProductListItem(id: number, itemId: string, cartItem: api.CartItemDto, options?: UpdateProductListItemOptions): Promise<api.Response<api.ProductListWithProductsDto>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    },
    path: {
      id,
      itemId
    },
    body: {
      cartItem
    }
  };
  return gateway.request(updateProductListItemOperation, parameters);
}

/**
 * Move items from one product list to another
 * 
 * @param {number} targetListId Target Product List ID
 * @param {number} sourceListId Source Product List ID
 * @param {module:types.ProductListMoveItemsDto} productListMoveItems 
 * @param {object} options Optional options
 * @param {string} [options.XStoreIdentifier] From what store are we searching, by default the Origin header is used
 * @return {Promise<module:types.ProductListWithProductsDto[]>} 
 */
export function moveProductListItems(targetListId: number, sourceListId: number, productListMoveItems: api.ProductListMoveItemsDto, options?: MoveProductListItemsOptions): Promise<api.Response<api.ProductListWithProductsDto[]>> {
  if (!options) options = {};
  const parameters: api.OperationParamGroups = {
    path: {
      targetListId,
      sourceListId
    },
    body: {
      productListMoveItems
    },
    header: {
      'X-Store-Identifier': options.XStoreIdentifier
    }
  };
  return gateway.request(moveProductListItemsOperation, parameters);
}

export interface MyListsOptions {
  /**
   * Storefront base URL for context e.g. *mystore.mygrano.fi*
   */
  XStoreIdentifier?: string;
}

export interface CreateOptions {
  /**
   * Storefront base URL for context e.g. *mystore.mygrano.fi*
   */
  XStoreIdentifier?: string;
  body?: {
    type: 'persisted-shopping-cart'|'my-products'|'cxml'|'custom',
    products: {
      id: string,
      options: any,
      price?: any,
      productFlowData?: any,
      product: {
        id?: number,
        updated_at?: string,
        locale?: any,
        images?: {
          master?: {
            fitIn_80x80?: string,
            fitIn_270x270?: string,
            fitIn_470x470?: string,
            fitIn_670x670?: string,
            fitIn_1200x630?: string,
            fitIn_2000x2000?: string
          }
        }
      }
    }[],
    metadata: {
      title?: string
    }
  };
}

export interface UpdateOptions {
  /**
   * Storefront base URL for context e.g. *mystore.mygrano.fi*
   */
  XStoreIdentifier?: string;
  body?: {
    products: {
      id: string,
      options: any,
      price?: any,
      productFlowData?: any,
      product: {
        id?: number,
        updated_at?: string,
        locale?: any,
        images?: {
          master?: {
            fitIn_80x80?: string,
            fitIn_270x270?: string,
            fitIn_470x470?: string,
            fitIn_670x670?: string,
            fitIn_1200x630?: string,
            fitIn_2000x2000?: string
          }
        }
      }
    }[],
    metadata: {
      title?: string
    }
  };
}

export interface DestroyOptions {
  /**
   * Storefront base URL for context e.g. *mystore.mygrano.fi*
   */
  XStoreIdentifier?: string;
}

export interface GetProductListsOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface CreateProductListOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface UpdateProductListOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface DeleteProductListOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface AddProductListItemOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface RemoveProductListItemOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface UpdateProductListItemOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

export interface MoveProductListItemsOptions {
  /**
   * From what store are we searching, by default the Origin header is used
   */
  XStoreIdentifier?: string;
}

const myListsOperation: api.OperationInfo = {
  path: '/product-list/my-lists',
  method: 'get',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const createOperation: api.OperationInfo = {
  path: '/product-list',
  contentTypes: ['application/json'],
  method: 'post',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const updateOperation: api.OperationInfo = {
  path: '/product-list/{id}',
  contentTypes: ['application/json'],
  method: 'put',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const destroyOperation: api.OperationInfo = {
  path: '/product-list/{id}',
  method: 'delete',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const getProductListsOperation: api.OperationInfo = {
  path: '/v2/product-list',
  method: 'get',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const createProductListOperation: api.OperationInfo = {
  path: '/v2/product-list',
  contentTypes: ['application/json'],
  method: 'post',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const updateProductListOperation: api.OperationInfo = {
  path: '/v2/product-list/{id}',
  contentTypes: ['application/json'],
  method: 'put',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const deleteProductListOperation: api.OperationInfo = {
  path: '/v2/product-list/{id}',
  method: 'delete',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const addProductListItemOperation: api.OperationInfo = {
  path: '/v2/product-list/{id}/items',
  contentTypes: ['application/json'],
  method: 'post',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const removeProductListItemOperation: api.OperationInfo = {
  path: '/v2/product-list/{id}/items/{itemId}',
  method: 'delete',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const updateProductListItemOperation: api.OperationInfo = {
  path: '/v2/product-list/{id}/items/{itemId}',
  contentTypes: ['application/json'],
  method: 'put',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};

const moveProductListItemsOperation: api.OperationInfo = {
  path: '/v2/product-list/{sourceListId}/move-to/{targetListId}',
  contentTypes: ['application/json'],
  method: 'post',
  security: [
    {
      id: 'apiKeyAuth'
    }
  ]
};
